import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizeService } from '../../shared/services/authorize.service';
import { filter, switchMap, take } from 'rxjs';

export const hasCompanyGuard: CanActivateFn = (route) => {
  const authorizeService = inject(AuthorizeService);
  const router = inject(Router);

  return authorizeService.authNavStatus$.pipe(
    filter((isAuthenticated) => isAuthenticated),
    take(1),
    switchMap(() => {
      const companies = authorizeService.user?.profile['companies'] as
        | {
            Id: number;
            Name: string;
          }[]
        | {
            Id: number;
            Name: string;
          }
        | string;
      const companyId = Number(route.params['companyId']);

      if (!companies || !companyId) {
        router.navigate(['/']);
        return [false];
      }

      if (companies === 'all') {
        return [true];
      }

      if (Array.isArray(companies)) {
        return [companies.some((company) => company.Id === companyId)];
      }

      if (typeof companies === 'object') {
        return [companies.Id === companyId];
      }

      return [false];
    })
  );
};
